import _classCallCheck from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/hyuto/Hyuto.github.io/v3-beta/node_modules/@babel/runtime/helpers/esm/createClass.js";

/**
 * Contains global resources of a model.
 */
export var ResourceManager = /*#__PURE__*/function () {
  function ResourceManager() {
    var hashTableNameToHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var hashTableMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ResourceManager);

    this.hashTableNameToHandle = hashTableNameToHandle;
    this.hashTableMap = hashTableMap;
  }
  /**
   * Register a `HashTable` in the resource manager.
   *
   * The `HashTable` can be retrieved by `resourceManager.getHashTableById`,
   * where id is the table handle tensor's id.
   *
   * @param name Op node name that creates the `HashTable`.
   * @param hashTable The `HashTable` to be added to resource manager.
   */


  _createClass(ResourceManager, [{
    key: "addHashTable",
    value: function addHashTable(name, hashTable) {
      this.hashTableNameToHandle[name] = hashTable.handle;
      this.hashTableMap[hashTable.id] = hashTable;
    }
    /**
     * Get the table handle by node name.
     * @param name Op node name that creates the `HashTable`. This name is also
     *     used in the inputs list of lookup and import `HashTable` ops.
     */

  }, {
    key: "getHashTableHandleByName",
    value: function getHashTableHandleByName(name) {
      return this.hashTableNameToHandle[name];
    }
    /**
     * Get the actual `HashTable` by its handle tensor's id.
     * @param id The id of the handle tensor.
     */

  }, {
    key: "getHashTableById",
    value: function getHashTableById(id) {
      return this.hashTableMap[id];
    }
    /**
     * Dispose `ResourceManager`, including its hashTables and tensors in them.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      for (var key in this.hashTableMap) {
        this.hashTableMap[key].clearAndClose();
        delete this.hashTableMap[key];
      }

      for (var name in this.hashTableNameToHandle) {
        this.hashTableNameToHandle[name].dispose();
        delete this.hashTableNameToHandle[name];
      }
    }
  }]);

  return ResourceManager;
}();